export default "__VITE_ASSET__BlRl7m9z__"